import {inject, Injectable} from '@angular/core'
import {HttpClient} from '@angular/common/http'
import {AuthService} from './auth-service'
import {Observable, of, Subject, switchMap, throwError} from 'rxjs'
import {IGitLabAuth} from '../1-application/types'
import {environment} from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class GitlabTokenService {

  private readonly http = inject(HttpClient)

  /**
   * Main holder of the token, saves it in local storage
   * and provides it via a signal.
   */
  private readonly service = inject(AuthService)

  /**
   *
   */
  private readonly refreshing$ = new Subject<IGitLabAuth>()

  /**
   * Semafor
   */
  private refreshing = false

  /**
   * Returns credentials if valid, if not valid, not refreshable
   * an error is thrown.
   */
  public setCredentials(): Observable<Partial<IGitLabAuth>> {
    const token = this.service.gitLabToken()
    return this.checkToken(token)
  }

  /**
   * Check if a token needs to be refreshed and do so if needed.
   */
  private checkToken(token: Partial<IGitLabAuth>): Observable<Partial<IGitLabAuth>> {
    if (!token?.expires) {
      return throwError(() => new Error('No valid token'))
    }
    if ((token.expires - 120_000) < Date.now()) {
      if (this.refreshing) {
        return this.refreshing$
      }
      return this.refresh(token)
    }
    return of(token)
  }

  /**
   * Refresh the access token, note that it uses "backend" not
   * GitLab directly. It is _not_ protected by "auth".
   */
  private refresh(token: Partial<IGitLabAuth>): Observable<Partial<IGitLabAuth>> {
    this.refreshing = true
    const url = `${environment.apiUrl}/refresh-gitlab?rt=${token.refresh_token}`
    return this.http.get<IGitLabAuth>(url)
      .pipe(
        switchMap(res => {
          this.refreshing = false
          if (!res.access_token) {
            return throwError(() => new Error('Refresh not possible'))
          }
          this.refreshing$.next(res)
          this.service.updateGitlabToken(res)
          return of(res)
        })
      )
  }
}
